import { render, staticRenderFns } from "./Container.global.vue?vue&type=template&id=5224d7a6&lang=pug&"
import script from "./Container.global.vue?vue&type=script&lang=ts&"
export * from "./Container.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports